import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import TrustBar from '../components/TrustBar';
import HeroIllustration from '../components/HeroIllustration';
import { IconIncognito, IconPerson, IconSearch, IconChevronCircle, IconDocument } from '../components/icons';

function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  // Repassa a unidade sugerida pelo QR (spec 2.6) para quem escolher denunciar.
  const unidadePre = location.state?.unidadePre;

  return (
    <div className="hero-page">
      <section className="hero">
        <div className="hero__content">
          <p className="eyebrow">Ouvir · Proteger · Construir juntos</p>
          <h1 className="hero__title">
            Um canal direto para relatar <span className="hero__title-accent">o que não está certo</span>
          </h1>
          <p className="hero__lede">
            Denúncias de assédio, corrupção, fraude ou qualquer conduta contrária
            à ética são recebidas aqui e tratadas com sigilo pela equipe de
            compliance do Grupo Vilarouca.
          </p>

          <div className="hero__actions">
            <button
              className="hero-btn hero-btn--primary"
              onClick={() => navigate('/denuncia-anonima', { state: { unidadePre } })}
            >
              <IconIncognito />
              <span className="hero-btn__label">
                <strong>Fazer denúncia anônima</strong>
                <small>Nenhum dado pessoal é coletado</small>
              </span>
              <IconChevronCircle className="hero-btn__arrow" />
            </button>

            <button
              className="hero-btn hero-btn--secondary"
              onClick={() => navigate('/denuncia-identificada', { state: { unidadePre } })}
            >
              <IconPerson />
              <span className="hero-btn__label"><strong>Fazer denúncia identificada</strong></span>
              <IconChevronCircle className="hero-btn__arrow" />
            </button>
          </div>

          <button className="hero__link" onClick={() => navigate('/acompanhamento')}>
            <IconSearch />
            Já denunciei — acompanhar andamento
          </button>

          <div className="hero__secondary">
            <p className="hero__secondary-label">Também é possível:</p>
            <div className="hero__secondary-actions">
              <button className="chip-btn" onClick={() => navigate('/manifestacao/reclamacao', { state: { unidadePre } })}>
                Fazer reclamação
              </button>
              <button className="chip-btn" onClick={() => navigate('/manifestacao/sugestao', { state: { unidadePre } })}>
                Fazer sugestão
              </button>
              <button className="chip-btn" onClick={() => navigate('/manifestacao/elogio', { state: { unidadePre } })}>
                Fazer elogio
              </button>
            </div>
          </div>

          {process.env.REACT_APP_WHATSAPP_NUMERO && (
            <a
              className="hero__whatsapp"
              href={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMERO}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconDocument />
              <span>
                <strong>Falar pelo WhatsApp</strong>
                <small>Atendimento confidencial, porém identificado — para anonimato, use o formulário</small>
              </span>
            </a>
          )}
        </div>

        <div className="hero__art">
          <HeroIllustration />
          <div className="hero__quote">
            <p>Integridade fortalece nossas relações.</p>
            <div className="hero__quote-org">Grupo Vilarouca</div>
            <p className="hero__quote-tag">Pessoas íntegras<br />empresas mais fortes</p>
          </div>
        </div>
      </section>

      <TrustBar />
    </div>
  );
}

export default Home;
